import React from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion"
import Modal from "react-modal"
import ReactTooltip from "react-tooltip"
import { isEmpty } from "lodash"
import { toast } from "react-toastify"
import Webcam from "react-webcam"
import Draggable from "react-draggable"
import Button from "components/common/Button"
import PageContainer from "components/common/PageContainer"
import ModuleCover from "./components/module-cover"
import Video from "./components/video"
import InteractiveVideo from "./components/interactive-video"
import Youtube from "./components/youtube"
import Audio from "./components/audio"
import Soundcloud from "./components/soundcloud"
import ExternalSection from "./components/external-section"
import HTMLSection from "./components/html-section"
import Survey from "./components/survey"
import ClassForm from "./components/class-form/index"
import Exam from "./components/exam"
import Panel from "components/panel"
import RecordScreen from "components/record"
import AlertNotification from "components/alert"
import {
  getCoursewareById,
  patchNotes,
  completeCourseware,
  toggleJoinClass,
  getUserProfile,
  showResponseModal,
  closeResponseModal,
  showConfirmModal,
  closeConfirmModal,
  endCourse,
} from "store/user/actions"
import { setLMSTheme } from "store/courses/action"
import { RESPONSE_MODAL_TYPES } from "constants/modal-types"
import { MCLE_SNAPSHOT } from "constants/message"
import { ADMIN_ROLE } from "constants/auth-types"
import {
  fetchCourseById,
  uploadSnapshot,
  showClassKYCModal,
  hideClassKYCModal,
  verifyUserSelfie,
} from "store/courses/action"
import { renderIconFileTypes } from "helpers/util"
import history from "app/history"
import "styles/pages/learning-module.scss"
import { ContentLoader } from "components/common/Loader"
import moment from "moment"
import { GOOGLE_ANALYTICS_KEY } from "constants/config"
import ReactGA from "react-ga"
ReactGA.initialize(GOOGLE_ANALYTICS_KEY)

const MINUTE = 60 * 1000
class LearningModule extends React.Component {
  constructor() {
    super()

    this.state = {
      notes: "",
      pageWidth: 0,
      timeLeft: 0,
      kylEnabled: false,
      snapshotActive: false,
      snapshotError: false,
      isLoadingCamera: true,
      hasMediaDevice: true,
      attemptEnded: false,
      mediaPaused: false,
      videoHeight: 480,
      videoWidth: 640,
      activeTab: 0,
      selfieImage: null,
      verificationSuccess: false,
    }
    this.webcamRef = React.createRef()
  }

  updateWindowDimensions = () => {
    this.setState({ pageWidth: window.innerWidth })
  }

  componentDidMount() {
    const {
      location: { pathname },
      auth: { isAuthorized, userId, role },
      courses: { selectedCourse },
      fetchCourseById,
      getUserProfile,
    } = this.props

    let currentPath = pathname.split("/")
    if (currentPath[3] === "module" && !isEmpty(currentPath[4])) {
      let id = currentPath[4]

      if (!isEmpty(selectedCourse)) {
        this.getCoursewareDetails(parseInt(id))
      }
    }

    if (currentPath[1] === "course" && !isEmpty(currentPath[2])) {
      let id = currentPath[2].split(/[\s-]+/).pop()
      fetchCourseById(id)
    }

    if (isAuthorized) {
      getUserProfile({ userId: userId, role })
    }
    ReactGA.pageview(window.location.pathname + window.location.search)
    this.updateWindowDimensions()
    window.addEventListener("resize", this.updateWindowDimensions)
    window.addEventListener("contextmenu", this.preventDefault)
    window.addEventListener("visibilitychange", this.checkTabActive)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions)
    window.removeEventListener("contextmenu", this.preventDefault)
    window.removeEventListener("visibilitychange", this.checkTabActive)

    clearInterval(this.interval)
    clearTimeout(this.timeout)
    clearInterval(this.courseTimer)

    if (this.state.snapshotActive) {
      this.closeCamera()
    }
  }

  preventDefault = (event) => {
    event.preventDefault()
  }

  checkTabActive = () => {
    if (document?.visibilityState === "hidden") {
      this.pauseSnapshot()
    }
  }

  getLatestCourseware = (modules = [], id) => {
    const {
      user: { coursewareDetails },
    } = this.props

    let latestCourseware = null
    let completedCoursewares = []

    modules.some((module) => {
      module.coursewares.some((courseware) => {
        if (coursewareDetails.id === courseware.id) {
          if (!coursewareDetails.completed && !courseware.completed) {
            latestCourseware = courseware.id
            return true
          }
        } else if (!courseware.completed) {
          latestCourseware = courseware.id
          return true
        }
        completedCoursewares.push(parseInt(courseware.id))
        return false
      })

      return latestCourseware !== null
    })

    if (completedCoursewares.includes(parseInt(id))) {
      return id
    } else {
      return latestCourseware
    }
  }

  getCoursewareDetails = (id) => {
    const {
      location: { pathname },
      user: { coursewareDetails },
      courses: {
        selectedCourse: { config, modules },
      },
      auth: { role },
      getCoursewareById,
    } = this.props

    if (config?.forward_streaming || ADMIN_ROLE.includes(role)) {
      if (parseInt(id) !== parseInt(coursewareDetails.id)) {
        getCoursewareById({ id: id })
      }
    } else {
      let coursewareId = this.getLatestCourseware(modules, id)

      if (
        coursewareId &&
        parseInt(coursewareId) !== parseInt(coursewareDetails.id)
      ) {
        let nextPath = pathname.replace(id, coursewareId)

        if (parseInt(id) === parseInt(coursewareId)) {
          getCoursewareById({ id: coursewareId })
        } else {
          history.replace(nextPath)
        }
      }
    }
  }

  closeCamera() {
    let video = document.getElementById("video")
    const stream = video.srcObject
    const tracks = stream?.getTracks() || []

    tracks.forEach(function (track) {
      track.stop()
    })

    video.srcObject = null

    this.setState({
      snapshotActive: false,
    })
  }

  componentDidUpdate(prevProps) {
    const {
      location: { pathname: prevPathname },
      courses: {
        selectedCourse: prevSelectedCourse,
        isLoadingSelectedCourse: prevIsLoadingSelectedCourse,
        isUploadingSnapshot: prevIsUploadingSnapshot,
        isVerifyingSelfie: prevIsVerifyingSelfie,
      },
    } = prevProps

    const {
      location: { pathname },
      fetchCourseById,
      courses: {
        selectedCourse = {},
        isLoadingSelectedCourse,
        isUploadingSnapshot,
        isVerifyingSelfie,
        snapshotError,
        verificationError,
      },
      school: { schoolData = {} },
      auth: { role },
      showConfirmModal,
    } = this.props

    if (
      !isEmpty(selectedCourse) &&
      !isEmpty(schoolData) &&
      this.state.isLoadingCamera
    ) {
      if (!this.state.snapshotActive) {
        if (selectedCourse?.config?.enable_kyl && role === "ST") {
          this.setState({
            kylEnabled: true,
          })

          this.resumeSnapshot()
        } else {
          this.setState({
            isLoadingCamera: false,
          })
        }
      }
    }

    if (!isLoadingSelectedCourse && prevIsLoadingSelectedCourse) {
      const { enrollment = {} } = selectedCourse

      if (
        enrollment?.progress === 100 &&
        moment().isBefore(
          moment(enrollment?.date_completed).add(2, "minutes")
        ) &&
        enrollment?.status !== "pay_later"
      ) {
        let message = (
          <>
            <p>
              You have successfully finished this course. You will be notified
              once your certificate is available.
            </p>
            {enrollment.reward && (
              <p>
                As a reward for completing this course, you will receive{" "}
                {enrollment.reward} L2E coins in your Apptitude wallet.
              </p>
            )}
            <p>Thank you!</p>
          </>
        )
        let modalData = {
          modalType: RESPONSE_MODAL_TYPES.SUCCESS,
          header: "CONGRATULATIONS",
          message: message,
          confirmLabel: "Go to Dashboard",
          cancelLabel: "Continue Browsing",
          confirmAction: () =>
            enrollment?.reward
              ? history.push("/student/apt-wallet")
              : history.push("/student/certificates"),
        }
        showConfirmModal(modalData)
      } else if (
        enrollment?.progress === 100 &&
        enrollment?.status === "pay_later"
      ) {
        let modalData = {
          modalType: RESPONSE_MODAL_TYPES.SUCCESS,
          header: "CONGRATULATIONS",
          message:
            "You have successfully finished this course. If you wish to get your certificate, click the Pay Now Button",
          confirmLabel: "Pay Now",
          cancelLabel: "Continue Browsing",
          confirmAction: () =>
            history.push(`/course/payment/${selectedCourse?.slug}`),
        }
        showConfirmModal(modalData)
      }
    }

    if (pathname !== prevPathname) {
      let currentPath = pathname.split("/")
      let prevPath = prevPathname.split("/")

      if (currentPath[3] === "module" && !isEmpty(currentPath[4])) {
        let id = currentPath[4]

        if (!isEmpty(selectedCourse)) {
          this.getCoursewareDetails(parseInt(id))
        }
      }

      if (currentPath[1] === "course" && !isEmpty(currentPath[2])) {
        let id = currentPath[2].split(/[\s-]+/).pop()
        let prevId = prevPath[2].split(/[\s-]+/).pop()

        if (id !== prevId) {
          fetchCourseById(id)
        }
      }
    }

    if (selectedCourse && selectedCourse !== prevSelectedCourse) {
      this.setState({
        notes: selectedCourse?.enrollment?.notes,
        timeLeft: selectedCourse?.attempt?.time_left,
      })

      let currentPath = pathname.split("/")
      if (currentPath[3] === "module" && !isEmpty(currentPath[4])) {
        let id = currentPath[4]
        if (!isEmpty(selectedCourse)) {
          this.getCoursewareDetails(parseInt(id))
        }
      }
      if (
        (!["paid", "pay_later"].includes(selectedCourse?.enrollment?.status) &&
          role === "ST") ||
        selectedCourse?.enrollment?.access_has_expired
      ) {
        history.push(`/course/${selectedCourse?.slug}`)
      }
      this.startTimer()
    }

    if (
      !isUploadingSnapshot &&
      isUploadingSnapshot !== prevIsUploadingSnapshot
    ) {
      if (snapshotError) {
        this.setState({
          snapshotError: snapshotError,
        })
        this.pauseSnapshot()
      }
    }

    if (!isVerifyingSelfie && isVerifyingSelfie !== prevIsVerifyingSelfie) {
      if (verificationError) {
        this.setState({
          verificationError: verificationError,
        })
      } else {
        this.setState({
          verificationSuccess: "You can now proceed to the lobby",
        })
      }
    }
  }

  handleOnBackClick() {
    const {
      location: { pathname },
      courses: { selectedCourse },
      endCourse,
    } = this.props

    endCourse({ id: selectedCourse.id })
    let currentPath = pathname.split("/")
    history.push(`/course/${currentPath[2]}`)
  }

  handleSaveNotes() {
    const {
      patchNotes,
      user: { coursewareDetails },
    } = this.props

    const { notes } = this.state

    let data = {
      notes: notes,
    }

    patchNotes({ id: coursewareDetails.enrollment, data: data })
  }

  handleNoteChange = (e) => {
    const { name, value } = e.currentTarget

    this.setState({
      [name]: value,
    })
  }

  handleMarkAsCompleted = () => {
    const {
      user: { coursewareDetails },
      courses: {
        selectedCourse: { enrollment },
      },
      completeCourseware,
    } = this.props

    if (enrollment?.progress < 100 && !coursewareDetails.completed) {
      completeCourseware({ id: coursewareDetails.id })
    }
  }

  handleCoursewareChange = (id, completed, previous_completed) => {
    const {
      location: { pathname },
      user: { coursewareDetails },
      courses: {
        selectedCourse: { config, enrollment },
      },
      auth: { role },
    } = this.props
    if (
      config.forward_streaming ||
      enrollment?.progress === 100 ||
      completed ||
      previous_completed ||
      ADMIN_ROLE.includes(role)
    ) {
      let nextPath = pathname.replace(coursewareDetails.id, id)
      history.push(nextPath)
    }
  }

  startTimer = () => {
    if (this.courseTimer) {
      clearInterval(this.courseTimer)
    }

    const { showResponseModal, closeResponseModal } = this.props

    this.courseTimer = setInterval(() => {
      const {
        courses: {
          selectedCourse: { enrollment },
        },
      } = this.props
      const { timeLeft } = this.state

      if (timeLeft - 1 < 1) {
        clearInterval(this.courseTimer)
        this.pauseSnapshot()

        this.setState({
          attemptEnded: true,
        })

        if (enrollment?.progress < 100) {
          let modalData = {
            header: "Oops, Sorry!",
            verified: true,
            modalType: RESPONSE_MODAL_TYPES.ERROR,
            message:
              "Timer has ended and you weren't able to finish within the time allocated for this course. Don't worry, you can retake the course, but your progress will be reset.",
            actionLabel: "OK",
            action: () => {
              this.handleOnBackClick()
              closeResponseModal()
            },
          }

          showResponseModal(modalData)
        }
      }

      this.setState({
        timeLeft: timeLeft - 1,
      })
    }, 1000)
  }

  takeSnapshot = () => {
    let canvas = document.getElementById("canvas")
    if (canvas) {
      let context = canvas.getContext("2d")
      let video = document.getElementById("video")

      const { videoHeight, videoWidth } = this.state
      const {
        courses: { selectedCourse },
        uploadSnapshot,
      } = this.props

      context.drawImage(video, 0, 0, videoWidth, videoHeight)
      let dataURL = canvas.toDataURL()

      let payload = {
        image: dataURL,
        course_id: selectedCourse.id,
      }

      uploadSnapshot(payload)
    }
  }

  generateInterval = () => {
    const { interval = [] } = this.state

    let r
    while (interval.length < 10) {
      r = Math.floor(Math.random() * 60) + 1
      if (interval.indexOf(r) === -1) interval.push(r)
    }
    r = interval.sort(function (a, b) {
      return a - b
    })

    this.setState({ interval })
  }

  takeRandomSnapshot = () => {
    const { interval = [], startTime: start = 0, snapshotActive } = this.state

    if (!snapshotActive) return

    let nextTime
    if (interval.length > 0) {
      let firstItem = interval.shift()
      nextTime = firstItem - start

      this.setState({
        startTime: firstItem,
        nextTime,
        interval,
      })

      this.takeSnapshot(firstItem)
    } else {
      this.setState({
        startTime: 0,
        nextTime: 1,
      })
    }

    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => {
      this.takeRandomSnapshot()
    }, nextTime * MINUTE)
  }

  startSnapshot = () => {
    let video = document.getElementById("video")

    if (this.interval) {
      clearInterval(this.interval)
    }

    this.generateInterval()
    this.interval = setInterval(() => {
      this.generateInterval()
    }, 60 * MINUTE)

    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      // Not adding `{ audio: true }` since we only want video now
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then((stream) => {
          video.srcObject = stream
          video.muted = true
          video.play()

          video.onloadedmetadata = () => {
            this.setState({
              videoHeight: video.videoHeight,
              videoWidth: video.videoWidth,
            })
          }

          this.setState({
            isLoadingCamera: false,
          })

          setTimeout(() => {
            this.takeRandomSnapshot()
          }, 2500)
        })
        .catch((err) => {
          console.log("ERROR: ", err)
          this.setState({
            hasMediaDevice: false,
            snapshotActive: false,
            isLoadingCamera: false,
          })
        })
    } else {
      this.setState({
        hasMediaDevice: false,
        snapshotActive: false,
        isLoadingCamera: false,
      })
    }
  }

  pauseSnapshot = () => {
    const { snapshotActive } = this.state

    if (snapshotActive) {
      clearInterval(this.interval)
      clearTimeout(this.timeout)

      this.setState({
        mediaPaused: true,
      })

      this.closeCamera()
    }
  }

  resumeSnapshot = async () => {
    const { snapshotActive } = this.state

    if (!snapshotActive) {
      await this.setState({
        snapshotActive: true,
        hasMediaDevice: true,
        isLoadingCamera: true,
        mediaPaused: false,
        snapshotError: false,
      })
      this.startSnapshot()
    }
  }

  handleNextCourseWare = () => {
    const {
      location: { pathname },
      user: { coursewareDetails },
      courses: {
        selectedCourse: { modules = [] },
      },
      auth: { role },
    } = this.props

    if (coursewareDetails.next) {
      const nextPath = pathname.replace(
        coursewareDetails.id,
        coursewareDetails.next
      )
      history.push(nextPath)
    } else {
      let nextCourseware = null

      modules.some((module) => {
        module.coursewares.some((courseware) => {
          if (!courseware.completed && !ADMIN_ROLE.includes(role)) {
            nextCourseware = courseware.id
            return true
          }
          return false
        })

        return nextCourseware !== null
      })

      if (nextCourseware) {
        const nextPath = pathname.replace(coursewareDetails.id, nextCourseware)
        history.push(nextPath)
      } else {
        toast.info("You have reached the last courseware")
      }
    }
  }

  handleJoinClass = () => {
    /* If verification is required before going to studios lobby, uncomment the following lines */
    // const { showClassKYCModal } = this.props

    // this.pauseSnapshot()
    // showClassKYCModal()

    this.handleProceedToLobby()
  }

  hideClassKYCModal = () => {
    const { hideClassKYCModal } = this.props

    this.setState({
      selfieImage: null,
      verificationError: false,
      verificationSuccess: false,
    })

    this.resumeSnapshot()
    hideClassKYCModal()
  }

  handleSubmitSelfie = () => {
    const { verifyUserSelfie } = this.props
    const { selfieImage } = this.state

    if (selfieImage) {
      verifyUserSelfie({
        image: selfieImage,
        verificationError: false,
      })
    }
  }

  handleWebcamScreenshot = () => {
    let screenshot = this.webcamRef.current.getScreenshot()
    this.setState({
      selfieImage: screenshot,
      verificationError: false,
    })

    if (this.webcamRef.current) {
      this.webcamRef.current.video.pause()
    }
  }

  handleSelfieRetake = () => {
    if (this.webcamRef.current) {
      this.setState({
        selfieImage: null,
        verificationError: false,
      })
      this.webcamRef.current.video.play()
    }
  }

  handleProceedToLobby = () => {
    const {
      user: { coursewareDetails },
      toggleJoinClass,
    } = this.props

    let conferenceInfo = {
      confRoomName:
        coursewareDetails?.conference_room?.code || coursewareDetails.slug,
      useStudios: coursewareDetails?.conference_room?.use_studios,
      url: coursewareDetails?.conference_room?.url,
    }

    toggleJoinClass(conferenceInfo)
    this.hideClassKYCModal()
  }

  renderCourseware(data) {
    const {
      user: { userDetails },
      courses: {
        selectedCourse: { config },
      },
    } = this.props

    const { mediaPaused } = this.state

    switch (data.type) {
      case "audio":
        return (
          <Audio
            data={data}
            sessionPaused={mediaPaused}
            onPause={this.pauseSnapshot}
          />
        )

      case "class":
        return (
          <ClassForm
            coursewareDetails={data}
            userInfo={userDetails}
            toggleJoinClass={() => this.handleJoinClass()}
          />
        )

      case "exam":
        return <Exam data={data} onNextCourseware={this.handleNextCourseWare} />

      case "html":
        return (
          <HTMLSection
            coursewareDetails={data}
            onMarkComplete={this.handleMarkAsCompleted}
          />
        )

      case "link":
        return (
          <ExternalSection
            coursewareDetails={data}
            config={config}
            onMarkComplete={this.handleMarkAsCompleted}
          />
        )

      case "pdf":
        return (
          <ExternalSection
            coursewareDetails={data}
            config={config}
            onMarkComplete={this.handleMarkAsCompleted}
          />
        )

      case "sc":
        return (
          <Soundcloud
            data={data}
            sessionPaused={mediaPaused}
            onMarkComplete={this.handleMarkAsCompleted}
            onPause={this.pauseSnapshot}
          />
        )

      case "survey":
        return (
          <Survey data={data} onNextCourseware={this.handleNextCourseWare} />
        )

      case "video":
        return (
          <Video
            data={data}
            config={config}
            sessionPaused={mediaPaused}
            onPause={this.pauseSnapshot}
          />
        )

      case "ivideo":
        return (
          <InteractiveVideo
            data={data}
            config={config}
            sessionPaused={mediaPaused}
            onPause={this.pauseSnapshot}
          />
        )

      case "yt":
        return (
          <Youtube
            data={data}
            sessionPaused={mediaPaused}
            onPause={this.pauseSnapshot}
          />
        )

      default:
    }
  }

  onChangeTab = (index) => {
    this.setState({
      activeTab: index,
    })
  }

  renderPanel = (modules, config, notes) => {
    const {
      courses: {
        selectedCourse: { enrollment = {} },
      },
      user: { coursewareDetails = {} },
      school: { schoolData = {} },
      auth: { role },
    } = this.props

    const { activeTab } = this.state
    const selectedTabStyle = { borderBottomColor: schoolData.primary_color }
    const currentCoursewareStyle = {
      backgroundColor: schoolData.primary_color + "3d",
    }
    return (
      <Panel>
        <Tabs
          className="tab-container -module"
          onSelect={this.onChangeTab}
          selectedTabClassName="select-tab"
        >
          <TabList className="tab-list">
            <Tab
              className="tab"
              style={activeTab === 0 ? selectedTabStyle : {}}
            >
              Course Content
            </Tab>
            <Tab
              className="tab"
              style={activeTab === 1 ? selectedTabStyle : {}}
            >
              Notes
            </Tab>
          </TabList>
          <TabPanel className="tab-panel">
            <div className="module-list">
              <Accordion allowZeroExpanded allowMultipleExpanded>
                {modules?.map((item) => (
                  <AccordionItem
                    key={item.id}
                    uuid={item.id}
                    dangerouslySetExpanded
                  >
                    <AccordionItemHeading aria-expanded={true}>
                      <AccordionItemButton>
                        <div className="module-button">
                          <h4 className="module-title">{item.name}</h4>
                          <p className="module-subtitle">
                            {`${
                              item.coursewares.filter((item) =>
                                coursewareDetails.id === item.id
                                  ? coursewareDetails.completed ||
                                    item.completed
                                  : item.completed
                              ).length
                            } of ${item.courseware_count} Coursewares`}
                          </p>
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <ul className="modules">
                        {item.coursewares?.map((courseware, index) => (
                          <li
                            style={Object.assign(
                              {
                                cursor:
                                  config?.forward_streaming ||
                                  enrollment?.progress === 100 ||
                                  courseware.completed ||
                                  courseware.previous_completed ||
                                  ADMIN_ROLE.includes(role)
                                    ? "pointer"
                                    : "default",
                              },
                              coursewareDetails.id === courseware.id
                                ? currentCoursewareStyle
                                : {}
                            )}
                            key={courseware.id}
                            onClick={() =>
                              this.handleCoursewareChange(
                                courseware.id,
                                courseware.completed,
                                courseware.previous_completed
                              )
                            }
                          >
                            <div className="module-label">
                              <span
                                className={renderIconFileTypes(courseware.type)}
                              />
                              <p className="label">
                                {`${index + 1}. ${courseware.name}`}
                              </p>
                            </div>
                            {(
                              coursewareDetails.id === courseware.id
                                ? coursewareDetails.completed ||
                                  courseware.completed
                                : courseware.completed
                            ) ? (
                              <span
                                className="icon-check"
                                style={{ color: schoolData.primary_color }}
                              />
                            ) : (
                              <span className="icon-uncheck" />
                            )}
                          </li>
                        ))}
                      </ul>
                    </AccordionItemPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </TabPanel>
          <TabPanel className="tab-panel">
            <div className="notes-container">
              <textarea
                className="textarea"
                placeholder="Add notes here"
                value={notes}
                name="notes"
                onChange={this.handleNoteChange}
              ></textarea>
              <Button
                label={"Save Notes"}
                onClick={() => {
                  this.handleSaveNotes()
                }}
              />
            </div>
          </TabPanel>
        </Tabs>
      </Panel>
    )
  }

  renderPauseModalContent = (snapshotError) => {
    let title = ""
    let body = ""

    if (snapshotError === "noMediaDevice") {
      title = "Video Device Inaccessible"
      body = (
        <>
          <h3>Apptitude can't access your camera</h3>
          <p>
            Sorry, this browser does not support webcam and other capabilities
            required for this course. Please update or use another browser.
          </p>
        </>
      )
    } else if (snapshotError === "faceDetection") {
      title = "Paused course session"
      body = (
        <>
          <h3>
            Face is not detected. Please ensure that viewer’s whole face is
            visible to the camera.
          </h3>
          <p>
            Furthermore, kindly also ensure that the camera is:
            <ul>
              <li>turned on</li>
              <li>not in use by other software</li>
              <li>
                is allowed on the browser (padlock icon beside web address bar
                or settings)
              </li>
            </ul>
          </p>
          <p>
            Click on the button below when you are ready to resume your session.
          </p>
        </>
      )
    } else if (snapshotError === "retryLimit") {
      title = "Failed to upload snapshot"
      body = (
        <>
          <h3>Sorry, something went wrong.</h3>
          <p>
            Please try again or contact{" "}
            <a href="mailto:admin@apptitude.xyz">admin@apptitude.xyz</a> if
            problem persists.
          </p>
        </>
      )
    } else if (snapshotError === "serverError") {
      title = "Oops, something went wrong"
      body = (
        <>
          <h3>
            The server encountered an error and could not complete your request.
            Please try again in 30 seconds.
          </h3>
        </>
      )
    } else {
      title = "Paused Course Session"
      body = (
        <>
          <h3>
            You may take a break and get back to the course when you are ready
          </h3>
          <p>
            You can also close the window/tab if taking longer. While your
            course is paused, the random snapshots will also be on hold, and you
            won't be able to access the course. Click on the button below to
            resume session.
          </p>
          <h3>
            Caution: The time limit to finish the course will continue to run.
          </h3>
        </>
      )
    }

    return (
      <>
        <span className="response-modal-header" style={{ marginTop: 0 }}>
          {title}
        </span>
        <div className="response-modal-message">{body}</div>
        <div className="button-group">
          <Button label="Resume Course" onClick={this.resumeSnapshot} />
        </div>
      </>
    )
  }

  render() {
    const {
      courses: {
        selectedCourse: { name, modules, config, enrollment },
        isLoadingSelectedCourse,
        isVerifyingSelfie,
        showClassKYCModal,
        lmsTheme,
      },
      user: {
        coursewareDetails,
        isLoadingEnrollments,
        isLoadingCoursewareDetails,
      },
      school: { schoolData },
      setLMSTheme,
    } = this.props

    const {
      notes,
      pageWidth,
      timeLeft = 0,
      snapshotActive,
      hasMediaDevice,
      videoHeight,
      videoWidth,
      isLoadingCamera,
      kylEnabled,
      selfieImage,
      verificationError,
      verificationSuccess,
    } = this.state

    const isCourseComplete = enrollment?.progress === 100
    // const courseAttemptEnded = attemptEnded || attempt?.ended

    let snapshotError = this.state.snapshotError

    let showPauseModal = kylEnabled && hasMediaDevice && !snapshotActive

    if (kylEnabled && !hasMediaDevice) {
      showPauseModal = true
      snapshotError = "noMediaDevice"
    }

    let displayTimer = false
    if (config?.duration && timeLeft > 0 && !isCourseComplete) {
      let duration = moment.duration(timeLeft, "seconds")
      let hours = duration.hours() + duration.days() * 24
      displayTimer =
        (hours < 10 ? "0" : "") +
        hours +
        ":" +
        (duration.minutes() < 10 ? "0" : "") +
        duration.minutes() +
        ":" +
        (duration.seconds() < 10 ? "0" : "") +
        duration.seconds()
    }

    return (
      <PageContainer
        isPageLoading={
          (isLoadingSelectedCourse && isLoadingEnrollments) || isLoadingCamera
        }
        className={`module-container ${lmsTheme}`}
        withoutFooter
      >
        <AlertNotification
          text={MCLE_SNAPSHOT}
          show={kylEnabled && snapshotActive && hasMediaDevice}
        />
        <ModuleCover
          title={name}
          onClick={() => this.handleOnBackClick()}
          redirectText="Exit Course"
          activeColor={schoolData.primary_color}
          ongoingExam
          moduleContent={
            pageWidth <= 1024 && this.renderPanel(modules, config, notes)
          }
          displayTimer={displayTimer}
          onToggleTheme={() => setLMSTheme(lmsTheme ? "" : "-dark")}
          LMStheme={lmsTheme}
        />
        <div className="module-page">
          {isLoadingCoursewareDetails ? (
            <Panel>
              <div className="module-header-loading">
                <ContentLoader loading={isLoadingCoursewareDetails} />
              </div>
            </Panel>
          ) : (
            <Panel>
              <div className="title-container">
                <div className="module-details">
                  <h3 className="module-title">
                    {`${coursewareDetails.module?.name}`}
                  </h3>
                  <p className="module-description">
                    {coursewareDetails.module?.description}
                  </p>
                </div>
                <div className="actions">
                  {snapshotActive && (
                    <div className="recording-notice">
                      <RecordScreen tooltip={MCLE_SNAPSHOT} />
                      <Button
                        data-tip="Pause course session"
                        label="Pause"
                        outlined={false}
                        onClick={this.pauseSnapshot}
                        color="#474b5a"
                        ghost
                      />
                      <ReactTooltip place="left" effect="solid" />
                    </div>
                  )}
                </div>
              </div>
              <div className="courseware-container">
                {this.renderCourseware(coursewareDetails)}
              </div>
            </Panel>
          )}
          {pageWidth >= 1024 && this.renderPanel(modules, config, notes)}
          <div>
            {/* <video id="video" autoPlay hidden /> */}
            <canvas
              id="canvas"
              width={videoWidth}
              height={videoHeight}
              hidden
            />
          </div>
          <Modal
            isOpen={showPauseModal}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
            className="response-modal"
            overlayClassName="response-modal-overlay -darker"
          >
            <div className="response-modal-container">
              {this.renderPauseModalContent(snapshotError)}
            </div>
          </Modal>
          <Modal
            isOpen={showClassKYCModal}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={true}
            onRequestClose={this.hideClassKYCModal}
            className="response-modal"
            overlayClassName="response-modal-overlay -darker"
          >
            <div className="response-modal-container">
              <h2 className="response-modal-header" style={{ marginTop: 0 }}>
                Verify Identity
              </h2>
              <Webcam
                ref={this.webcamRef}
                audio={false}
                screenshotFormat="image/jpeg"
                videoConstraints={{
                  facingMode: "user",
                  height: 480,
                  width: 640,
                }}
                width={640}
                mirrored={true}
              />
              <div className="response-modal-message mb-s">
                Identity verification is required prior to the start of the
                synchronous session. Click the camera button above then click
                submit once you are satisfied with the photo.
                {verificationError && (
                  <p className="form-error">{verificationError}</p>
                )}
                {verificationSuccess && (
                  <p className="form-success">{verificationSuccess}</p>
                )}
              </div>
              {selfieImage ? (
                verificationSuccess ? (
                  <div className="button-group">
                    <Button
                      size="large"
                      label="Proceed to Lobby"
                      onClick={this.handleProceedToLobby}
                    />
                  </div>
                ) : (
                  <div className="button-group">
                    <Button
                      size="large"
                      label="Submit for Verification"
                      loading={isVerifyingSelfie}
                      onClick={this.handleSubmitSelfie}
                    />
                    {!isVerifyingSelfie && (
                      <Button
                        ghost
                        size="large"
                        label="Retake Photo"
                        onClick={this.handleSelfieRetake}
                      />
                    )}
                  </div>
                )
              ) : (
                <div className="button-group">
                  <Button
                    size="large"
                    label="Take a snapshot"
                    onClick={this.handleWebcamScreenshot}
                  />
                </div>
              )}
            </div>
          </Modal>
        </div>
        {snapshotActive && (
          <Draggable>
            <div className="video-preview">
              <p className="title">Preview of Mandatory Snapshots</p>
              <video id="video" autoPlay playsInline />
              <p className="caption">
                Please make sure your face is in full view.{" "}
                <span style={{ fontWeight: "700" }}>If in case</span> you do not
                see yourself, kindly do not proceed and send a screenshot to
                admin@apptitude.xyz.
              </p>
            </div>
          </Draggable>
        )}
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  courses: state.coursesReducer,
  user: state.userReducer,
  school: state.schoolReducer,
  auth: state.authReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCoursewareById,
      fetchCourseById,
      patchNotes,
      completeCourseware,
      toggleJoinClass,
      getUserProfile,
      uploadSnapshot,
      showResponseModal,
      closeResponseModal,
      showConfirmModal,
      closeConfirmModal,
      endCourse,
      showClassKYCModal,
      hideClassKYCModal,
      verifyUserSelfie,
      setLMSTheme,
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(LearningModule)
